import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";
import music from '../../public/audio/music.mp3'; // Asegúrate de ajustar la ruta

export default create(subscribeWithSelector((set, get) => {
    let intervalId;
    const musicAudio = new Audio(music); // Crear la instancia del audio una sola vez

    const startCountdown = () => {
        const { phase, setTimeLeft } = get();
        if (phase === "playing") {
            intervalId = setInterval(() => {
                const { timeLeft, restart } = get();
                if (timeLeft > 0) {
                    setTimeLeft(timeLeft - 1);
                } else {
                    set({ phase: "ended" });
                    clearInterval(intervalId);
                    restart(); // Reinicia el juego automáticamente
                }
            }, 1000);
        }
    };

    const stopCountdown = () => {
        clearInterval(intervalId);
    };

    const startMusic = () => {
        musicAudio.loop = true; // Asegúrate de que los audios se reproduzcan en bucle
        musicAudio.play();
    };

    const stopMusic = () => {
        musicAudio.pause();
        musicAudio.currentTime = 0; // Reinicia la pista al principio
    };

    return {
        // TIME
        startTime: 0,
        endTime: 0,
        timeLeft: 300, // 5 minutes in seconds

        // PHASES
        phase: "ready",
        setTimeLeft: (time) => set({ timeLeft: time }),
        start: () => {
            set((state) => {
                if (state.phase === "ready") {
                    set({ phase: "playing", startTime: Date.now() });
                    startCountdown();
                    startMusic(); // Inicia la música cuando el juego comienza
                }
                return {};
            });
        },
        restart: () => {
            set((state) => {
                if (state.phase === "playing" || state.phase === "ended") {
                    stopCountdown();
                    stopMusic(); // Detiene la música al reiniciar
                    startMusic(); // Reinicia la música
                    return { phase: "ready", timeLeft: 300, booksRemaining: 16, bookVisible: Array(16).fill(true) };
                }
                return {};
            });
        },
        end: () => {
            set((state) => {
                if (state.phase === "playing") {
                    stopCountdown();
                    stopMusic(); // Detiene la música al terminar el juego
                    return { phase: "ended", endTime: Date.now() };
                }
                return {};
            });
        },

        // BOOKS
        booksRemaining: 16,
        bookVisible: Array(16).fill(true),
        collectBook: (index) => set((state) => {
            const newVisibility = [...state.bookVisible];
            newVisibility[index] = false;
            return { booksRemaining: state.booksRemaining - 1, bookVisible: newVisibility };
        }),
    };
}));
